import { ApiConfig } from './ApiConfigs';
import { ApiServices } from './apiServices';

const BASE = ApiConfig.URL + '/api/franchise';

export const franchiseService = {
    // Admin: List all franchises
    list: () => ApiServices('get', BASE),

    // Admin: Get all franchises + order counts (overview)
    overview: () => ApiServices('get', `${BASE}/overview`),

    // Admin: Get single franchise
    getById: (id) => ApiServices('get', `${BASE}/${id}`),

    // Admin: Create franchise
    create: (data) => ApiServices('post', BASE, data),

    // Admin: Update franchise
    update: (id, data) => ApiServices('put', `${BASE}/${id}`, data),

    // Admin: Delete franchise
    delete: (id) => ApiServices('delete', `${BASE}/${id}`),

    // Admin: Get orders for a franchise (with optional date range and pagination)
    getOrders: (id, params = {}) => {
        const qs = new URLSearchParams();
        if (params.from) qs.set('from', params.from);
        if (params.to) qs.set('to', params.to);
        if (params.page) qs.set('page', params.page);
        if (params.limit) qs.set('limit', params.limit);
        if (params.status) qs.set('status', params.status);
        const query = qs.toString();
        return ApiServices('get', `${BASE}/${id}/orders${query ? '?' + query : ''}`);
    },

    // Admin: Get stats for a franchise
    getStats: (id, params = {}) => {
        const qs = new URLSearchParams();
        if (params.from) qs.set('from', params.from);
        if (params.to) qs.set('to', params.to);
        const query = qs.toString();
        return ApiServices('get', `${BASE}/${id}/stats${query ? '?' + query : ''}`);
    },

    // Admin: Toggle delivery coverage radius
    toggleRadius: (id, data) => ApiServices('put', `${BASE}/${id}/radius`, data),

    // Check delivery coverage
    checkCoverage: (params = {}) => {
        const qs = new URLSearchParams(params).toString();
        return ApiServices('get', `${BASE}/check-delivery-coverage${qs ? '?' + qs : ''}`);
    },

    // Franchise: Login
    login: (email, password) =>
        ApiServices('post', ApiConfig.URL + '/api/franchise/login', { email, password }),
};

